// src/components/SolutionCheckboxList.js
import React, { useEffect, useState } from 'react';
import { useServiceOptions } from '../utils/serviceOptions';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { useTranslation } from 'react-i18next';

const SolutionCheckboxList = (props) => {
  const serviceOptions = useServiceOptions();
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && props.steps?.aiResponse?.value?.length > 0) {
      setSelected(props.steps.aiResponse.value);
      setInitialized(true);
    }
  }, [initialized, props.steps]);

  const handleChange = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (selected.length === 0) {
      setError(t('pacobot.checkBoxRequired'));
      return;
    }
    if (props.triggerNextStep) {
      props.triggerNextStep({ value: selected });
    }
  };


  return (
    <div>
      {serviceOptions.map(option => (
        <div key={option.id} style={{ display: 'block', marginBottom: '6px' }}>
          <label
            data-tooltip-id="service-tooltip"
            data-tooltip-content={option.description}
            style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={selected.includes(option.id)}
              disabled={isSubmitted}
              onChange={() => handleChange(option.id)}
              style={{ marginRight: '8px' }}
            />
            {option.label}
          </label>
        </div>
      ))}
      {!isSubmitted && (
        <Tooltip
          id="service-tooltip"
          place="top"
          float={true}
        />
      )}
      <button
        onClick={handleSubmit}
        disabled={isSubmitted}
        style={{
          marginTop: '12px',
          backgroundColor: isSubmitted ? '#aaa' : '#7c3aed',
          color: isSubmitted ? '#eee' : 'white',
          border: '2px solid white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontWeight: 'bold',
          fontSize: '16px',
          cursor: isSubmitted ? 'default' : 'pointer',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          pointerEvents: isSubmitted ? 'none' : 'auto',
          opacity: isSubmitted ? 0.6 : 1,
          transition: 'all 0.3s ease'
        }}
        onMouseOver={e => e.currentTarget.style.backgroundColor = '#6b21a8'}  // Hover darker
        onMouseOut={e => e.currentTarget.style.backgroundColor = '#7c3aed'}
      >
        {t('pacobot.btnContinue')}
      </button>
    </div>
  );
};

export default SolutionCheckboxList;